if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart = document.getElementById('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');

        this.variantIdInput.disabled = false;

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const formData = new FormData(this.form);

        const addonCheckbox = document.querySelector('#addon-gift-tag');
        const addonVariantId = addonCheckbox?.dataset.addonVariant;
        const isAddonChecked = addonCheckbox?.checked && addonVariantId;

        fetch(routes.cart_add_url, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: formData
        })
          .then(r => r.json())
          .then((response) => {

            if (response.status) {
              this.handleErrorMessage(response.description);
              this.submitButton.removeAttribute('aria-disabled');
              return;
            }

            const addonPromise = isAddonChecked
              ? this.addAddonToCart(addonVariantId)
              : Promise.resolve(null);

            addonPromise.then(() => {

              window.refreshDrawer().then(() => {
                window.openCartDrawer?.();
              });

            });

          })
          .catch(console.error)
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
            this.submitButton.removeAttribute('aria-disabled');
          });
      }

      addAddonToCart(addonVariantId) {
        const formData = new FormData();
        formData.append('id', addonVariantId);
        formData.append('quantity', 1);

        return fetch(routes.cart_add_url, {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: formData
        })
          .then(r => r.json())
          .catch(err => {
            console.error('Addon error:', err);
            return null;
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

/* =========================
   GLOBAL CART FUNCTIONS
========================= */

window.openCartDrawer = function () {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-drawer-overlay');

  drawer?.classList.add('is-open');
  overlay?.classList.add('is-open');

  drawer?.removeAttribute('aria-hidden');
  overlay?.removeAttribute('aria-hidden');

  document.body.style.overflow = 'hidden';
};

window.closeCartDrawer = function () {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-drawer-overlay');

  drawer?.classList.remove('is-open');
  overlay?.classList.remove('is-open');

  drawer?.setAttribute('aria-hidden', 'true');
  overlay?.setAttribute('aria-hidden', 'true');

  document.body.style.overflow = '';
};

/* =========================
   DRAWER REFRESH (IMPORTANT)
========================= */

window.refreshDrawer = function () {
  return fetch('/?section_id=cart-drawer')
    .then(r => r.text())
    .then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newBody = doc.getElementById('cart-drawer-body');
      const oldBody = document.getElementById('cart-drawer-body');

      if (newBody && oldBody) {
        oldBody.innerHTML = newBody.innerHTML;
      }

      const count = doc.querySelector('[data-cart-count]')?.textContent;

      document.querySelectorAll('[data-cart-count]').forEach(el => {
        if (count) el.textContent = count;
      });

      return true;
    })
    .catch(console.error);
};